module.exports = __webpack_public_path__ + "197aa045b90f0ec9438a8db7b0670c96.png";